import { render, staticRenderFns } from "./StandardReportListBold.vue?vue&type=template&id=41b0d0a9"
import script from "./StandardReportListBold.vue?vue&type=script&lang=js"
export * from "./StandardReportListBold.vue?vue&type=script&lang=js"
import style0 from "./StandardReportListBold.vue?vue&type=style&index=0&id=41b0d0a9&prod&lang=css"
import style1 from "./StandardReportListBold.vue?vue&type=style&index=1&id=41b0d0a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports